"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importStar(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const index_1 = require("../index");
const OFFSET = 0;
const ANIMATION_DURATION = 500;
function GroupDetailsMobile({ group, isOpen, setIsClosed, className, }) {
    const containerRef = (0, react_1.useRef)(null);
    const onClose = () => {
        setIsClosed();
    };
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isOpen, timeout: ANIMATION_DURATION, mountOnEnter: true, appear: true, unmountOnExit: true, nodeRef: containerRef, "data-e2e": 'GroupDetailsMobile_CSSTransition', children: (0, jsx_runtime_1.jsxs)(Container, { ref: containerRef, "data-e2e": 'GroupDetailsMobile_Container', children: [(0, jsx_runtime_1.jsx)(IconContainer, { onClick: onClose, "data-e2e": 'GroupDetailsMobile_IconContainer', children: (0, jsx_runtime_1.jsx)(CloseIcon, { name: ui_1.Icons.Cross, "data-e2e": 'GroupDetailsMobile_CloseIcon' }) }), (0, jsx_runtime_1.jsx)(index_1.GroupDetails, { group: group, className: className, isMobile: true, "data-e2e": 'GroupDetailsMobile_GroupDetails' })] }) }));
}
exports.default = GroupDetailsMobile;
const hiddenStyles = (0, styled_components_1.css) `
  transform: translateY(100%);
`;
const visibleStyles = (0, styled_components_1.css) `
  transform: translateY(-${OFFSET}px);
`;
const Container = styled_components_1.default.div `
  position: fixed;
  top: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;

  padding-top: env(safe-area-inset-top);
  padding-top: constant(safe-area-inset-top);

  width: 100vw;
  height: 100vh;

  color: ${props => props.theme.text};
  background-color: ${props => props.theme.background};

  &.appear,
  &.enter {
    ${hiddenStyles}
  }

  &.appear-active,
  &.enter-active {
    ${visibleStyles};

    transition: transform ${ANIMATION_DURATION}ms ease-in;
  }

  &.appear-done,
  &.enter-done {
    ${visibleStyles};
  }

  &.exit {
    ${visibleStyles};
  }

  &.exit-active {
    ${hiddenStyles};

    transition: transform ${ANIMATION_DURATION}ms ease-in;
  }

  &.exit-done {
    ${hiddenStyles};
  }
`;
const IconContainer = styled_components_1.default.div `
  display: flex;
  position: relative;
  justify-content: end;
  left: calc(100% - 30px);

  width: 17px;
  height: 17px;
`;
const CloseIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 17px;
  height: 17px;

  cursor: pointer;

  color: ${props => props.theme.gray2};
`;
